export default "__VITE_ASSET__tTFtUskJ__"